export default {
  organisation: null,
  organisation_user: null,

  dpr_reports: [],
}